import { Section } from '@/pages/CompanyReport/components/Overview/components/Section';
import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const InactiveSummaryWrapper = styled(Section)`
  display: flex;
  position: relative;

  h4 {
    ${({ theme }) => theme.typography.baseStrong};
    padding-bottom: ${({ theme }) => theme.x1spacePx}px;
  }
`;

export const ContentWrapper = styled('div')`
  flex-grow: 1;

  > div {
    ${({ theme }) => theme.typography.xSmall};
    color: ${({ theme }) => theme.color.lightGray};
    margin-bottom: ${({ theme }) => theme.x3spacePx}px;
  }
`;

export const GraphicWrapper = styled('figure')`
  flex-shrink: 1;
  padding: 0 ${({ theme }) => theme.x4spacePx}px;

  ${media.smDown`
    display: none;
  `}
`;

export const CloseButtonWrapper = styled('div')`
  position: absolute;
  top: 0;
  right: 0;
  margin-right: ${({ theme }) => theme.x3spacePx}px;
  margin-top: ${({ theme }) => theme.x3spacePx}px;
`;
